// extracted by mini-css-extract-plugin
export default {"wrapper":"TranslateRow_wrapper__7in63","word":"TranslateRow_word__z6nQw","translation":"TranslateRow_translation__c31Dy"};